import { RedAsterisk } from '../input';
import { StyledTextareaWithLabel, TextareaLabel } from './styled';
import { Textarea, TextareaProps } from './Textarea';

export interface TextareaWithLabelProps extends TextareaProps {
  label: React.ReactNode;
  labelTooltip?: React.ReactNode;
}

export const TextareaWithLabel: React.FC<TextareaWithLabelProps> = ({
  label,
  labelTooltip,
  ...props
}) => (
  <StyledTextareaWithLabel>
    <TextareaLabel>
      {label}
      {props.required && <RedAsterisk />}
    </TextareaLabel>
    <Textarea {...props} />
  </StyledTextareaWithLabel>
);
